<ul *ngIf="toastMessageService.messages.length > 0"
    [class]="containerClass"
    [style]="containerStyle">
    @for (message of toastMessageService.messages; track message.id) {
        <li class="ml-auto mr-auto toast toast-context width-240" [ngClass]="message.css">
            <div class="toast-text width-full">
                @if (message.icon) {
                    <svg ycnIcon [name]="message.icon" [class]="message.icon" class="mr-1 fill-current"></svg>
                }
                <span [innerHTML]="message.innerHtml"></span>
            </div>
            <div class="divider-vertical ml-10"></div>
            <div class="btn btn-xs btn-circle btn-transparent btn-close"
                 data-test-id="toast-close"
                 (click)="toastMessageService.removeMessage(message.id)">
                <span>
                    <svg class="icon-close" role="img" ycnIcon [name]="'icon-close'"></svg>
                </span>
            </div>
        </li>
    }
</ul>
